export default {
  state: {
    isScreenModalShown: false,
    isSessionScreenModalShown: false,
    selectedScreenId: null,
  },
  getters: {
    isScreenModalShown: (state) => state.isScreenModalShown,
    isSessionScreenModalShown: (state) => state.isSessionScreenModalShown,
    selectedScreenId: (state) => state.selectedScreenId,
  },
  mutations: {
    setScreenModal(state, shown) {
      state.isScreenModalShown = shown
    },
    setSessionScreenModal(state, shown) {
      state.isSessionScreenModalShown = shown
    },
    setSelectedScreenId(state, screenId) {
      state.selectedScreenId = screenId
    }
  },
  actions: {
    showScreenModal({ commit }, screenId = null) {
      if (screenId !== null) {
        commit('setSelectedScreenId', screenId)
      }
      commit('setScreenModal', true)
    },
    hideScreenModal({ commit }) {
      commit('setScreenModal', false)
      commit('setSelectedScreenId', null)
    },
    showSessionScreenModal({ commit }, screenId = null) {
      if (screenId !== null) {
        commit('setSelectedScreenId', screenId)
      }
      commit('setSessionScreenModal', true)
    },
    hideSessionScreenModal({ commit }) {
      commit('setSessionScreenModal', false)
      commit('setSelectedScreenId', null)
    },
  },
  namespaced: true
};
